<div class="container-padding">
  <ng-container *ngIf="isValid == false">
    <div class="centered fail-mobile">
      <img
        style="width: 15rem"
        src="assets/images/tickets/failure.svg"
        alt=""
      />
      <div>
        <h2 class="title">{{ "BookingFailed" | translate }}</h2>
      </div>
      <button type="button" class="btn btn-primary btn-fail" [routerLink]="'/'">
        {{ "TryAgain" | translate }}
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="isValid">
    <div class="centered">
      <img
        style="width: 15rem"
        src="assets/images/tickets/success.svg"
        alt=""
      />
      <div>
        <h2 class="title">{{ "BookingSuccess" | translate }}</h2>
        <!--          <p>{{ "BookingSuccessMessage" | translate }}</p>-->
        <button
          type="button"
          class="btn btn-primary"
          (click)="downloadInvoice()"
        >
          <img src="assets/images/tickets/download.svg" class="px-2" />
          <span>{{ "DownloadAllTickets" | translate }}</span>
        </button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="tickets && tickets.orders?.length && isValid">
    <div class="tickets-container">
      <div class="d-flex justify-content-between px-4 mobile">
        <div>
          <div class="row">
            <p class="info-title">{{ "Event details" | translate }}</p>
          </div>
          <div class="row">
            <p class="info-value">
              {{ helpers.getElementTranslatedName(tickets.event) }}
            </p>
          </div>
          <div class="row">
            <p class="info-title">
              {{
                "tickets-bought-quantity"
                  | translate : { value: tickets?.orders?.length }
              }}
            </p>
          </div>
        </div>
        <div>
          <div class="row">
            <p class="info-title">{{ "your name" | translate }}</p>
          </div>
          <div class="row">
            <p class="info-value">
              {{ tickets?.metadata?.name?.first }}
              {{ tickets?.metadata?.name?.last }}
            </p>
          </div>
          <div class="row">
            <p style="unicode-bidi: plaintext" class="info-title">
              {{ tickets?.metadata?.mobile }}
            </p>
          </div>
        </div>
        <div>
          <div class="row">
            <p class="info-title">{{ "Amount" | translate }}</p>
          </div>
          <div class="row">
            <p class="info-value">
              <ng-container *ngIf="tickets?.total !== 0">
                <span
                  [innerHTML]="
                    tickets?.total
                      | number : '1.2-2'
                      | customCurrency : 'SAR' : 'symbol' : '#28293d' : 28
                  "
                ></span>
              </ng-container>

              <ng-container *ngIf="tickets?.total === 0">
                {{ "free" | translate }}
              </ng-container>
            </p>
          </div>
          <div class="row">
            <p class="info-title" *ngIf="tickets?.total !== 0">
              {{ "Tax Included" | translate }}
            </p>
          </div>
        </div>
      </div>
      <hr class="dashed" />
      <div style="padding: 5%; padding-top: 1%" class="pb-0">
        <app-order-item
          [order]="order"
          [event]="tickets.event"
          *ngFor="let order of tickets?.orders"
        ></app-order-item>
      </div>

      <!-- <div class="myTicket" *ngFor="let order of tickets?.orders">
        <div class="myTicket-part1">
          <div class="myTicket-qr">
            <div class="qrcodFrame">
              <div
                class="container_"
                *ngIf="
                  order.approvalStatus === ApprovalStatusEnum.WaitingApproval ||
                  order.approvalStatus === ApprovalStatusEnum.DeclinedApproval
                "
              >
                <div class="tag">
                  <h6
                    *ngIf="
                      order.approvalStatus ===
                      ApprovalStatusEnum.WaitingApproval
                    "
                  >
                    {{ "WaitingApproval" | translate }}
                  </h6>
                  <h6
                    *ngIf="
                      order.approvalStatus ===
                      ApprovalStatusEnum.DeclinedApproval
                    "
                  >
                    {{ "Rejected" | translate }}
                  </h6>
                </div>
                <img
                  src="{{
                    'https://api.qrserver.com/v1/create-qr-code/?data=' +
                      order.id +
                      '&margin=30&height=100'
                  }}"
                  alt=""
                  style="opacity: 0.4"
                  class="image"
                />
              </div>

              <img
                *ngIf="order.approvalStatus === ApprovalStatusEnum.Approved"
                src="{{
                  'https://api.qrserver.com/v1/create-qr-code/?data=' +
                    order.id +
                    '&margin=30&height=100'
                }}"
                alt=""
              />
            </div>
          </div>

          <div class="text-center myTicket-number">
            <h3 class="myTicket-user-name">
              {{ "TicketNumber" | translate }}
            </h3>
            <p class="myTicket-name">
              {{ order.number }}
            </p>
          </div>
          <div class="myTicket-user">
            <h3 class="myTicket-user-name">
              {{
                tickets.metadata.name.first + " " + tickets.metadata.name.last
              }}
            </h3>
            <p class="myTicket-user-phone">
              {{ tickets.metadata.mobile }}
            </p>
            <p class="myTicket-user-email">
              {{ tickets.metadata.email }}
            </p>
          </div>
        </div>

        <div class="myTicket-partSeparator">
          <div class="myTicket-partSeparator-line"></div>
        </div>
        <div class="myTicket-part2">
          <h3 class="myTicket-name">
            {{ order.ticket.nameAr }}
          </h3>
          <ng-container *ngIf="order.ticket.isScheduled">
            <p class="myTicket-price">
              {{ order.schedule.startAt * 1000 | date : "dd/MM/yyyy" }}
            </p>
            <p class="myTicket-price">
              {{
                order.time?.startAt
                  ? (order.time?.startAt | formatHour)
                  : ("allDay" | translate)
              }}
            </p>
          </ng-container>
          <p class="myTicket-price" *ngIf="order.total > 0">
            {{ order.total }}
            {{ "SR" | translate }}
          </p>
          <p class="myTicket-price" *ngIf="order.total === 0">
            {{ "free" | translate }}
          </p>
        </div>
      </div> -->
    </div>
  </ng-container>
</div>

<div class="book-footer">
  <button routerLink="/" class="btn pay-now-btn back-mobile">
    <i
      *ngIf="translate.currentLang == 'ar'"
      class="fas fa-arrow-right mx-2"
    ></i>
    <i *ngIf="translate.currentLang == 'en'" class="fas fa-arrow-left mx-2"></i>

    {{ "Go back" | translate }}
  </button>
</div>
